import {types} from './report.actions';

const initialState = {
    deliveriesByApp: { 
        values: {
            countCargasPlanejadas: 0,
            countCargasRealizadas: 0,
            countOcorrencias: 0,
        }, 
        filters: {
            carrier: {
                documentNumber: null,
                name: "TODOS",
            },
            period: {
                description:"Últimos 7 dias",
                period: "LAST_SEVEN_DAYS"
            },
        },
        lookup:{
            showCarrier: false,
            showPeriod: false,
            columnsCarrier:[
                {
                    field: "razaoSocial",
                    header: "Razão social",
                    columnKey: "razaoSocial",
                    sortable: false,
                    filter: true
                   
                  }
            ],
            columnsPeriod:[
                {
                    field: "description",
                    header: "Período",
                    columnKey: "description",
                    sortable: false,
                    filter: true
                   
                  }
            ]
        }
    }
}

export function reducerDeliveriesByAppIndicator(state = initialState, action){
    let result = state;
    switch(action.type){
        case types.SET_VALUE:
            return setValue(state, action);
        case types.SET_NAME:
            return setName(state, action);
        case types.SET_CNPJ:
            return setCNPJ(state, action);
        case types.SET_PERIOD:
            return setPeriod(state, action);
        case types.SET_SHOW_CARRIER:
            return setShowCarrier(state, action);
        case types.SET_SHOW_PERIOD:
            return setShowPeriod(state, action);   
        case types.LOADER_SHOW:
            return loaderShow(state, action);
        case types.LOADER_HIDDEN:
            return loaderHide(state, action);                   
        default:
        return result; 
    }
}

function setValue(state, action){
    const deliveriesByApp = {...state.deliveriesByApp, values:action.value}
    return Object.assign({}, state, {deliveriesByApp});
}

function setName(state, action){
    return Object.assign({}, state, { value: action.name }); 
}

function setCNPJ(state, action){
    const filters = {...state.deliveriesByApp.filters,carrier:action.carrier}
    const deliveriesByApp = {...state.deliveriesByApp, filters}
    return Object.assign({}, state, {deliveriesByApp}); 
}

function setPeriod(state, action){
    const filters = {...state.deliveriesByApp.filters, period:action.period}
    const deliveriesByApp = {...state.deliveriesByApp, filters}
    return Object.assign({}, state, {deliveriesByApp});  
}

function setShowCarrier(state, action){
    const lookup = {...state.deliveriesByApp.lookup, showCarrier:action.showCarrier}
    const deliveriesByApp = {...state.deliveriesByApp, lookup}
    return Object.assign({}, state, {deliveriesByApp}); 
}

function setShowPeriod(state, action){
    const lookup = {...state.deliveriesByApp.lookup, showPeriod:action.showPeriod}
    const deliveriesByApp = {...state.deliveriesByApp, lookup}
    return Object.assign({}, state, {deliveriesByApp}); 
}

function loaderShow(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

function loaderHide(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

